import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Composant pour afficher une erreur inline sous un champ de formulaire
 */
export const FieldError = ({ error }) => {
  if (!error) return null;
  
  return (
    <div className="flex items-center gap-1 mt-1 text-sm text-red-600">
      <AlertCircle className="h-4 w-4" />
      <span>{error}</span>
    </div>
  );
};

/**
 * Wrapper pour Input avec support d'erreur inline
 */
export const InputWithError = ({ 
  error, 
  children, 
  className = "",
  ...props 
}) => {
  const hasError = !!error;
  
  return (
    <div className="space-y-1">
      <div className={`${className} ${hasError ? 'border-red-500 focus-within:ring-red-500' : ''}`}>
        {children}
      </div>
      <FieldError error={error} />
    </div>
  );
};

export default FieldError;
